import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { FaSpinner, FaSearch } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import useIsMobile from 'utils/isMobileUtils';
import { Skeleton } from '@mui/material';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import { CommonDateOnlyFormat } from 'helpers/common.helper';


// ✅ Clear
const ShipmentItemsModal = ({ openPopup, details, addressDetails, handleClose, handleReloadData }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isExportLoading, setIsExportLoading] = useState(false);
    const [shippedItems, setShippedItems] = useState([]);
    const [data, setData] = useState([]);   
    const [searchValue, setSearchValue] = useState('');


    const isMobile = useIsMobile();

    useEffect(() => {
        api.getShippedItemsSerials(details?.id).then((res) => {
            if (res?.data?.status) {
                setShippedItems(res?.data?.data || []);
                setData(res?.data?.data || []);
            }
            setIsLoading(false);
        });
    }, []);
    

    const disablepopup = () => {
        handleClose();
    };

    const handleExport = () => {

        api.exportShippedItemsSerials(details?.id).then((res) => {
            setIsExportLoading(true)
            const newFileName = `Projectmix - Invoice ${details?.invoice_number} Serials`;
            if (res != 404) {
                var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(newBlob, `${newFileName}.xlsx`);
                // toast.dismiss(downloading);
                // setExportCompIsLoading(false);
                toast.success('Downloaded Completed!');
                // setShowExportModal(false);
            } else {
                // toast.dismiss(downloading);
                // setExportCompIsLoading(false);
                toast.error(res == 404 ? 'No Records Found!' : 'Download Failed!');
            }
            setIsExportLoading(false)
        });
    }



    return (
        <Modal show={openPopup} onHide={disablepopup} centered size="lg">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-left">

                                    <h5
                                        className="h5 mb-0 text-gray-900 font-weight-bold flex-grow-1 pt-0"
                                        style={{ fontWeight: '600' }}
                                    >
                                        Shipment Details
                                    </h5>
                                    <br />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <svg id="Component_127_1" height="16" width="16" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
                                    <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                                </svg>
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-lg-4 col-12">
                                <div className="row">
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Shipping Company</span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <div className={`${details?.shipping_company ? 'text-gray-700' : 'text-gray-500'}`}>{details?.shipping_company || 'N/A'}</div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Tracking #</span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <div className={`${details?.tracking_number ? 'text-gray-700' : 'text-gray-500'}`}>{details?.tracking_number || 'N/A'}</div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Shipped Items</span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <div className={`${details?.quantity ? 'text-gray-700' : 'text-gray-500'}`}>{details?.quantity || '0'}</div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Date Shipped </span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <div className={`${details?.date ? 'text-gray-700' : 'text-gray-500'}`}>{moment(details?.date).format(CommonDateOnlyFormat) || 'N/A'}</div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Weight </span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    details?.weight ? (
                                                        <div className={`text-gray-700`}> {details?.weight} {details?.weight_unit || ''} </div>
                                                    ) : (
                                                        <div className={`'text-gray-500`}>N/A</div>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-6 form-group">
                                        <span className="fw-500">Shipping Cost </span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    details?.shipping_cost ? (
                                                        <div className={`text-gray-700`}>
                                                            {details?.shipping_currency || ''}{' '}
                                                            {Number(details?.shipping_cost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </div>
                                                    ) : (
                                                        <div className={`text-gray-500`}>N/A</div>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-12 form-group">
                                        <span className="fw-500">Shipping Address </span>
                                        <div>
                                            {
                                                isLoading ? (
                                                    <div>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                ) : (
                                                    <div className={`${addressDetails ? 'text-gray-700' : 'text-gray-500'}`}>{addressDetails || 'N/A'}</div>
                                                )
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={`col-lg-8 col-12 ${isMobile ? 'border-top-gray' : 'border-left-gray'}`}>
                               
                                <div className="row" style={{ marginTop: `${isMobile ? '0' : '-20px'}` }}>
                                    <div className="col-12">
                                        <div className=" align-items-center justify-content-between TableSerachBar" style={{ display: 'flex'}}>
                                            <form className="form-inline navbar-search w-full" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
                                                {
                                                    isLoading ? (
                                                        <>
                                                            <div style={{ width: '100px' }}>
                                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                            </div>
                                                            <div className="input-group ml-auto" style={{ width: '200px' }}>
                                                                <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {shippedItems?.length > 0 && (
                                                                <button
                                                                    className={`btn btn-primary btn-outlined-main white-var ${isExportLoading ? 'disabled' : ''}`}
                                                                    disabled={isExportLoading}
                                                                    onClick={() => {
                                                                        if (!isExportLoading) {
                                                                            handleExport()    
                                                                        }
                                                                    }}
                                                                >
                                                                    {
                                                                        isExportLoading ? (
                                                                            <>
                                                                                <FaSpinner className="fa-spin" /> Exporting...
                                                                            </>
                                                                        ) : ( 
                                                                            <>
                                                                                <PiMicrosoftExcelLogoFill style={{ fontSize: '1.4em' }} /> Export
                                                                            </>
                                                                        )
                                                                    }
                                                                </button>
                                                            )}
                                                            <div className="input-group ml-auto">
                                                                <input
                                                                    type="text"
                                                                    className="form-control bg-white border"
                                                                    placeholder="Search"
                                                                    aria-label="Search"
                                                                    aria-describedby="basic-addon2"
                                                                    value={searchValue}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value.toLowerCase();
                                                                        setSearchValue(value);
                                                                        const filteredData = data.filter((item) =>
                                                                            item?.product_name?.toLowerCase().includes(value) ||
                                                                            item?.imei?.toLowerCase().includes(value)
                                                                        );
                                                                        setShippedItems(filteredData);
                                                                    }}
                                                                    style={{ width: '100%' }}
                                                                />
                                                                <span className="searchIcon">
                                                                    <FaSearch />
                                                                </span>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </form>
                                        </div>
                                        <div style={{ height: `${isMobile ? '300px' : '400px'}`, overflowY: 'auto', scrollbarWidth: 'thin', scrollbarColor: '#0966ff transparent' }}>
                                            <table className="table  min-width-unset tbl-space pm-table">
                                                <thead>
                                                    <tr className="sticky-header">
                                                        <th scope="col" className="text-center align-middle" style={{ width: '55px' }}></th>
                                                        <th scope="col" width="">Product</th>
                                                        <th scope="col" width={''}>IMEI</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        isLoading ? (
                                                            [...Array(100)].map((e, i) => (
                                                                <tr style={{ height: '35px' }} key={i}>
                                                                    {[...Array(3)].map((e, i) => (
                                                                        <td>
                                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))
                                                        ) : ( 
                                                            shippedItems?.length > 0 ? (
                                                                shippedItems?.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td className="text-center align-middle" style={{ width: '55px' }}>
                                                                            <img src={item?.thumbnail_url} alt="product" style={{ width: 'auto', height: '50px' }} />
                                                                        </td>
                                                                        <td className="align-middle" width="">{item?.product_name || 'N/A'}</td>
                                                                        <td className="align-middle" width="">{item?.imei || 'N/A'}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={3} className="text-center text-gray-600" style={{ height: '100px' }}>No shipped IMEIs available</td>
                                                                </tr>
                                                            )   
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="flex align-items-center justify-content-between mt-2">
                                            <div className="flex gap-2 align-items-center">
                                                <div>Total</div>
                                                {
                                                    isLoading ? (
                                                        <div style={{ width: '100px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
                                                        </div>
                                                    ): (
                                                        data?.length
                                                    )
                                                }
                                                
                                            </div>
                                            <div className="ml-auto">
                                                <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main" style={{ marginLeft: '4px' }}>
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ShipmentItemsModal;
